import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Slider } from "@/components/ui/slider";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { Target, Sliders } from "lucide-react";

export default function QuickCompressPanel({
  targetPercentage,
  setTargetPercentage,
  onQuickCompress,
  onPercentageCompress,
  isProcessing,
  hasImages
}) {
  if (!hasImages) return null;

  return (
    <Card className="border-orange-200 dark:border-orange-800 bg-gradient-to-r from-orange-50 to-amber-50 dark:from-orange-900/20 dark:to-amber-900/20 transition-colors duration-300">
      <CardContent className="p-4">
        <div className="space-y-4">
          {/* Target Size Mode */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <Target className="w-5 h-5 text-orange-600 dark:text-orange-400" />
              <div>
                <h3 className="text-sm font-bold text-slate-900 dark:text-white">Quick Compress</h3>
                <p className="text-xs text-slate-600 dark:text-slate-400">Compress to exact target size</p>
              </div>
            </div>
            <div className="flex flex-wrap gap-2">
              <Button
                onClick={() => onQuickCompress(50)}
                disabled={isProcessing}
                size="sm"
                className="rounded-full bg-orange-500 hover:bg-orange-600 text-white"
              >
                50 KB
              </Button>
              <Button
                onClick={() => onQuickCompress(100)}
                disabled={isProcessing}
                size="sm"
                className="rounded-full bg-orange-500 hover:bg-orange-600 text-white"
              >
                100 KB
              </Button>
              <Button
                onClick={() => onQuickCompress(200)}
                disabled={isProcessing}
                size="sm"
                className="rounded-full bg-orange-500 hover:bg-orange-600 text-white"
              >
                200 KB
              </Button>
              <Button
                onClick={() => onQuickCompress(500)}
                disabled={isProcessing}
                size="sm"
                className="rounded-full bg-orange-500 hover:bg-orange-600 text-white"
              >
                500 KB
              </Button>
            </div>
          </div>
          
          <Separator className="dark:bg-orange-800/50" />
          
          {/* Percentage Mode */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <Sliders className="w-5 h-5 text-amber-600 dark:text-amber-400" />
              <div>
                <h3 className="text-sm font-bold text-slate-900 dark:text-white">Compress by Percentage</h3>
                <p className="text-xs text-slate-600 dark:text-slate-400">Best quality at target size ratio</p>
              </div>
            </div>
            <div className="flex items-center gap-3 w-full sm:w-auto">
              <div className="flex-1 sm:w-48">
                <Slider
                  value={targetPercentage}
                  onValueChange={setTargetPercentage}
                  min={10}
                  max={90}
                  step={5}
                  className="w-full"
                />
              </div>
              <Badge variant="secondary" className="min-w-[4rem] text-center bg-amber-100 dark:bg-amber-900/50 text-amber-700 dark:text-amber-300">
                {targetPercentage[0]}%
              </Badge>
              <Button
                onClick={() => onPercentageCompress(targetPercentage[0])}
                disabled={isProcessing}
                size="sm"
                className="rounded-full bg-amber-500 hover:bg-amber-600 text-white"
              >
                Apply
              </Button>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
